var dateTime = {
	"dateFormats": {
		"time1": "",
		"date1": "D MMM, YYYY",
		"date2": "D/M/YYYY",
		"date3": "DD/MM/YYYY",
		"date4": "DDMMYYYY",
		"date5": "Do MMMM YYYY",
		"date6": "dddd, Do MMMM YYYY",
		"date7": "ddd, D MMM YYYY",
		"date8": "D/M",
		"date9": "ddd",
		"date10": "dddd, MMMM Do",
		"date11": "MMMM YYYY",
		"date12": "YYYYMMDD",
		"date13": "MMMM Do, YYYY",
		"dateTime1": "h:mm A, MMMM D, YYYY"
	},
	"dayNamesLong": 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' '),
	"dayNamesMedium": 'Sun Mon Tue Wed Thu Fri Sat'.split(' '),
	"dayNamesShort": 'Su Mo Tu We Th Fr Sa'.split(' '),
	"monthNamesLong": 'January February March April May June July August September October November December'.split(' '),
	"monthNamesShort": 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')
}

module.exports = dateTime;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/configs/config.datetime.js
 **/